module.exports = __webpack_public_path__ + "images/c94b913483e1ad2efd7716bc4d37ebf5.png";